import {SET_TRAINER_SEARCH, SET_TRAINER_ATTRIBUTES, SET_TRAINERS, SET_TRAINER } from '../types/types';

export const setTrainers = (value, count) => {
  return {
    type: SET_TRAINERS,
    payload: { data: value, count: count},
  };
};

export const setTrainer = (value) => {
  return {
    type: SET_TRAINER,
    payload: { data: value },
  };
};

export const setTrainerAttributes = (value) => {
    return {
      type: SET_TRAINER_ATTRIBUTES,
      payload: { data: value },
    };
  };

export const setTrainerSearch = (value) => {
  return {
    type:   SET_TRAINER_SEARCH,
    payload: { data: value },
  };
};
